import React from 'react'
import image from '../../../../assets/homepage_hp6.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const LowerSectionLatestProductRight = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 5,
            "name": "Headphone 5",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 6,
            "name": "Headphone 6",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
    ]
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
    }
    return (
        <>
            <h2 className="title1">Recently Viewed Products</h2>
            <Slider {...sliderSettings}>
                {products.map((i,index) => (
                    <div className="item" key={index}>
                        <div className="recent-bx">
                            <div className="bx-img">
                                <img className="img-fluid" src={i.image} alt="" />
                            </div>
                            <div className="prod-txt">
                                <h5>CAMERA</h5>
                                <h3>Vantech VP-153C Camera</h3>
                                <span className="mt-3">
                                    <img className="img-fluid" src="images/star.png" alt="" />
                                </span>
                                <h4>
                                    $195.00 <span>$229.99</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </>
    )
}

export default LowerSectionLatestProductRight